import { all, takeEvery, put, fork } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { getToken, getUser, clearLocalStorage } from '../../helpers/utility';
import actions from './actions';
import telepaseAction from '../telepase/actions';
import notification from '../../components/notification';
export function* loginRequest() {
  yield takeEvery('LOGIN_REQUEST', function*({ payload }) {
    const { token } = payload;
    if (token) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token: token,
      });
    } else {
      yield put({ type: actions.LOGIN_ERROR });
    }
  });
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function*(payload) {
    yield localStorage.setItem('id_token', payload.token);
    yield put({type: telepaseAction.SEARCH_USER});

  });
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function*() {});
}

export function* logout() {
  yield takeEvery(actions.LOGOUT, function*() {
    clearLocalStorage();
    yield put({
      type: telepaseAction.CLEAR_ALL
    });
    yield put(push('/'));
  });
}

export function* checkAuthorization() {
  yield takeEvery(actions.CHECK_AUTHORIZATION, function*() {
    const token = getToken().get('idToken');
    if (token) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token: token,
      });
    }
  });
}

export function* searchUser(){
  yield takeEvery(telepaseAction.SEARCH_USER, function*() {
    const user = yield getUser();
    if (user && !user.sector) {
      notification('error', 'Error', 'No tienes un sector asociado');
      yield put({
        type: actions.LOGOUT
      });
    } else if  (user) {
      yield put({
        type: telepaseAction.SAVE_USER,
        payload: user
      });
    } else {
      //yield put(push('/500'));
    }
  });
}





export default function* rootSaga() {
  yield all([
    fork(checkAuthorization),
    fork(searchUser),
    fork(loginRequest),
    fork(loginSuccess),
    fork(loginError),
    fork(logout)
  ]);
}
